// extracted by mini-css-extract-plugin
module.exports = {"content":"LoyaltyOverviewCard_content__ufFIx","column-title":"LoyaltyOverviewCard_column-title__UTSku"};